/* eslint-disable no-underscore-dangle */
import axios from 'axios';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL_ADMIN,
  timeout: 50000,
  withCredentials: true,
});

/**
 * Axios interceptor to pass the JWT token if exists
 * @param {import('axios').InternalAxiosRequestConfig} axiosConfig
 * @returns {import('axios').InternalAxiosRequestConfig}
 */
const onRequest = (axiosConfig) => {
  const newConfig = { ...axiosConfig };

  return newConfig;
};

/**
 * Refresh the access token
 * @param {import('axios').AxiosError & { config: { _retry?: boolean }}} axiosError
 * @returns {Promise<import('axios').AxiosResponse|import('axios').AxiosError>}
 */
const refreshAccessToken = async (axiosError) => {
  const originalRequest = axiosError.config;

  if (axiosError.response
    && axiosError.response.status === 401
    && !originalRequest._retry
    && originalRequest.url !== '/token/refresh'
  ) {
    originalRequest._retry = true;

    if (window.location.pathname !== '/token') {
      window.location.replace(`/token?path=${window.location.pathname}`);
      localStorage.removeItem('auth');
    }
  }
  if (axiosError.response
    && axiosError.response.status === 401
    && originalRequest.url === '/token/refresh') {
    localStorage.removeItem('auth');
  }

  return Promise.reject(axiosError.response?.data);
};

/**
 * Axios interceptor to manage API response
 * @param {import('axios').AxiosError<any, any> & { config: { _retry?: boolean; }; }} error
 * @returns {Promise<any>}
 */
const onRejected = (error) => refreshAccessToken(error);

instance.interceptors.request.use(onRequest);
instance.interceptors.response.use((res) => res, onRejected);

export default instance;
